import { getSortingOptions } from "@cruisen/react-shared"
import { observer } from "mobx-react-lite"
import styles from "./styles.module.scss"
import { RadioInput } from "../../atoms/RadioInput"

export const SortingModal = observer(
  ({ selectedOption, onClose }: { selectedOption: string; onClose: (option: string) => void }) => {
    const sortingOptions = getSortingOptions()

    return (
      <div className={styles.sortingList}>
        {sortingOptions.map((option) => (
          <RadioInput
            key={option.id}
            selectedOption={selectedOption}
            option={option}
            onClose={onClose}
          />
        ))}
      </div>
    )
  },
)
